import { render, staticRenderFns } from "./ReportesSeriePantalla.vue?vue&type=template&id=1a8366fa&"
import script from "./ReportesSeriePantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSeriePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1a8366fa', component.options)
    } else {
      api.reload('1a8366fa', component.options)
    }
    module.hot.accept("./ReportesSeriePantalla.vue?vue&type=template&id=1a8366fa&", function () {
      api.rerender('1a8366fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesNoSeriados/ReportesSeriePantalla.vue"
export default component.exports